import { render, staticRenderFns } from "./approved-monthly.vue?vue&type=template&id=386f095c&"
import script from "./approved-monthly.vue?vue&type=script&lang=js&"
export * from "./approved-monthly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports